<body>
  <div class="box">
    <h2>Login</h2>
    <form>
      <div class="inputBox">
        <input type="email" name="email" required onkeyup="this.setAttribute('value', this.value);" value="">
        <label>Username</label>
      </div>
      <div class="inputBox">
        <input type="password" name="password" required value="" onkeyup="this.setAttribute('value', this.value);"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters">
        <label>Password</label>
      </div>
      <input type="submit" name="sign-in" value="Sign In">
    </form>
  </div>
  <div class="box">
    <h2>Company Login</h2>
    <form>
      <div class="inputBox">
        <input type="email" name="email" required onkeyup="this.setAttribute('value', this.value);" value="">
        <label>Username</label>
      </div>
      <div class="inputBox">
        <input type="password" name="password" required value="" onkeyup="this.setAttribute('value', this.value);"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters">
        <label>Password</label>
      </div>
      <input type="submit" name="sign-in" value="Sign In">
    </form>
    <br />
    <p>login as company <a href="https://www.w3schools.com/">Log in</a></p>
  </div>
</body>